import { User, Home, Store, ShoppingCart, TrendingUp } from 'lucide-react';
import { PROFILE } from '../../profileInfo/constant/Routes';

export const navItems = [
  {
    id: 0,
    title: 'پروفایل من',
    icon: User,
    link: PROFILE,
  },
  {
    id: 1,
    title: 'خانه',
    icon: Home,
    link: '/',
  },
  {
    id: 2,
    title: 'فروشگاه',
    icon: Store,
    link: '/store',
  },
  {
    id: 3,
    title: 'سبد خرید',
    icon: ShoppingCart,
    link: '/cart',
  },
  {
    id: 4,
    title: 'معامله ',
    icon: TrendingUp,
    link: '/gold-trading',
  },
];
